<mat-dialog-content>
  <div class="d-flex flex-column align-items-center">
    <img
      src="assets/images/confirmation-icon.png"
      alt="confirm"
      class="mb-3"
      width="72"
      height="72"
    />
    <p class="color-dark fw-500 text-center" [innerHTML]="confirmationMsg"></p>
    <div class="d-flex align-items-center">
      <button
        class="btn btn-bordered me-2"
        (click)="confirmationDialogRef.close(false)"
      >
        Close
      </button>
      <button
        class="btn btn-primary"
        (click)="confirmationDialogRef.close(true)"
      >
        Confirm
      </button>
    </div>
  </div>
</mat-dialog-content>
